import { injectable } from "inversify";
import { Either, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import DashboardRepository, { BasicDashboardData } from "../../../domain/repositories/DashboardRepository";

@injectable()
export default class DashboardRepositoryImpl implements DashboardRepository {
    
    public getBasicData = async (): Promise<Either<ErrorEntity, BasicDashboardData>> => {
        //TODO implement real api call
        throw new Error("Method not implemented.");
    }
}